import { Property } from "@/types/property";
import { useCurrency } from "@/hooks/useCurrency";

interface PropDetailsPriceBreakdownProps {
  property: Property;
}

const PropDetailsPriceBreakdown = ({
  property,
}: PropDetailsPriceBreakdownProps) => {
  const { formatPrice } = useCurrency();

  if (property?.price == null) return null;

  const renderAmount = (amount?: number | null, fromCurrency?: string) => {
    if (amount == null) return null;
    return formatPrice(amount, fromCurrency);
  };

  return (
    <div className="w-full bg-slate-50/50 border border-slate-200/80 rounded-2xl p-5 shadow-xs">
      <h3 className="font-semibold text-sm text-slate-800 tracking-wide uppercase mb-4">
        Price Breakdown
      </h3>

      <div className="space-y-3 text-sm">
        <div className="flex items-center justify-between">
          <span className="text-slate-500 font-normal">Property Price</span>
          <span className="font-medium text-slate-900">
            {renderAmount(property?.price, property?.currency)}
          </span>
        </div>

        {property?.agency_fees && (
          <div className="flex items-center justify-between">
            <span className="text-slate-500 font-normal">Agency Fees</span>
            <span className="font-medium text-slate-900">
              {renderAmount(property?.agency_fees, property?.currency)}
            </span>
          </div>
        )}

        {property?.legal_fees && (
          <div className="flex items-center justify-between">
            <span className="text-slate-500 font-normal">Legal Fees</span>
            <span className="font-medium text-slate-900">
              {renderAmount(property?.legal_fees, property?.currency)}
            </span>
          </div>
        )}

        {property?.service_fee && (
          <div className="flex items-center justify-between">
            <span className="text-slate-500 font-normal">Service Fee</span>
            <span className="font-medium text-slate-900">
              {renderAmount(property?.service_fee, property?.currency)}
            </span>
          </div>
        )}

        {property?.caution_fee && (
          <div className="flex items-center justify-between">
            <span className="text-slate-500 font-normal">Caution Fee</span>
            <span className="font-medium text-slate-900">
              {renderAmount(property?.caution_fee, property?.currency)}
            </span>
          </div>
        )}

        <div className="flex items-center justify-between pt-3.5 mt-1 border-t border-slate-200">
          <span className="font-semibold text-slate-900">Total Package</span>
          <span className="font-bold text-base text-[#19545e]">
            {renderAmount(property?.total_package, property?.currency)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PropDetailsPriceBreakdown;
